import { ApiError, apiRequest } from '@/lib/api-client';
import { normalizeAnalyticsAddress } from '@/lib/investor-analytics';
import { hygieneResponseSchema, type HygieneResponse } from '../types/hygiene';

/**
 * Canonical Portfolio Hygiene assessment. Flag-gated on the backend: a plain
 * 404 means the feature is off for this deployment — callers treat that as
 * "canonical source unsupported", not as an error state.
 */
export async function fetchInvestorHygiene(
  address: string,
  chainId: number,
  signal?: AbortSignal
): Promise<HygieneResponse> {
  const investor = normalizeAnalyticsAddress(address);
  const response = await apiRequest(
    `/api/v1/investor/${encodeURIComponent(investor.toLowerCase())}/hygiene`,
    hygieneResponseSchema,
    { auth: 'required', chainId, signal }
  );

  if (
    response.scope.ownerAddress.toLowerCase() !== investor.toLowerCase() ||
    response.scope.chainId !== chainId
  ) {
    throw new ApiError('ROWA returned data that could not be verified.', {
      status: 200,
      code: 'invalid-response'
    });
  }

  return response;
}

export function isHygieneUnsupportedError(error: unknown): boolean {
  return error instanceof ApiError && error.status === 404;
}
